export default function invert(v) {
  if (typeof v === 'number') {
    return v ? 0 : 1;
  }
  return !v;
}
